const ABObjectApiCore = require("../core/ABObjectCore");
module.exports = class ABObjectApi extends ABObjectApiCore {};
